module.exports = __webpack_public_path__ + "static/20230619_191-9c313fb55622fc1239c14a37b8dda028.jpg";